import { getMonths } from "@data/timelineFilters";

import { Consultation, TreatmentPlan } from "@customTypes/consultation";
import { Immunization } from "@customTypes/immunization";
import { Laboratory } from "@customTypes/laboratory";
import { Prescription } from "@customTypes/prescription";
import { Radiology } from "@customTypes/radiology";
import { Referral } from "@customTypes/referral";
import { TimelineEvent, TimelineItem } from "@customTypes/timeline";

import { getFileTypeForDocumentation } from "./documentationFileType";

//* All types in FilterableData need to have "date" property
export type FilterableData =
  | Partial<Consultation>
  | Partial<Laboratory>
  | Partial<Radiology>
  | Partial<Prescription>
  | Partial<Immunization>
  | Partial<Referral>
  | Partial<TreatmentPlan>;

export const filterByYear = <T extends FilterableData>(
  targetYear: string,
  data: T[]
) => {
  return data?.filter(item => item.date?.getFullYear() === +targetYear) || [];
};

export const filterByMonth = <T extends FilterableData>(
  targetMonth: string,
  data: T[]
) => {
  const targetMonthNumber = getMonths().findIndex(
    month => month.value === targetMonth
  );

  if (targetMonthNumber >= 0) {
    return data.filter(item => {
      return item.date?.getMonth() === targetMonthNumber;
    });
  } else {
    console.error("Invalid month:", targetMonth);
    return [];
  }
};

export const filterByDay = <T extends FilterableData>(
  targetDay: string,
  data: T[]
) => {
  return data.filter(item => {
    // return (
    if ("day" in item) {
      return item.day === targetDay;
    } else {
      // console.log(item.date?.toLocaleDateString("en-US", { weekday: "long" }));
      return (
        item.date
          ?.toLocaleDateString("en-US", { weekday: "long" })
          .toLocaleLowerCase() === targetDay
      );
    }
    // );
  });
};

// Only for Timeline page
export const filterByCategory = (
  category: TimelineEvent["recordType"],
  data: TimelineItem[]
) => {
  return data
    .map(item => ({
      ...item,
      data: item.data.filter(event => event.recordType === category),
    }))
    .filter(item => item.data.length > 0);
};

// Only for Documentation page //! No longer used in filter dialog
export const filterByFileType = (
  fileType: "image" | "report",
  data: FilterableData[]
) => {
  return data.filter(item => {
    const { text } = getFileTypeForDocumentation((item as any).files);
    return text.includes(fileType);
  });
};

export const filterByPhysicians = (
  physician: string,
  data: FilterableData[]
) => {
  const filteredData = [];

  for (const i of data) {
    if ("physician" in i && i.physician?.fullName === physician) {
      filteredData.push(i);
    } else if ("orderedBy" in i && i.orderedBy?.fullName === physician) {
      filteredData.push(i);
    } else if ("prescribedBy" in i && i.prescribedBy?.fullName === physician) {
      filteredData.push(i);
    } else if (
      "administeredBy" in i &&
      i.administeredBy?.fullName === physician
    ) {
      filteredData.push(i);
    } else if ("doctor" in i && i.doctor === physician) {
      filteredData.push(i);
    }
  }
  return filteredData;
};
